"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'recording.start.failed': 'No se pudo iniciar la grabación',
};
